import * as React from 'react';
import { api } from 'services/api';

type Params = {
  taskId: number;
}

export const useDeleteTask = () => {
  const deleteTask = React.useCallback(async (params: Params) => {
    const url = `/inventory/service-order-tasks/${params.taskId}`;
    await api.delete(url);
  }, []);

  return {
    deleteTask,
  };
};